import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => {
  const frameWidth = `${theme.spacing(0.25)}px`;
  const framePadding = theme.spacing(5);
  return {
    container: {
      position: 'relative',
      height: `min(70vh, 80vw)`,
      width: `min(70vh, 80vw)`,
      padding: theme.spacing(1),
      alignSelf: 'center',
      backgroundColor: theme.palette.gray.dark,
      borderRadius: theme.spacing(2),
      '&:before, &:after, &>:first-child:before, &>:first-child:after': {
        position: 'absolute',
        width: theme.spacing(7.5),
        height: theme.spacing(7.5),
        borderColor: theme.palette.white.main,
        borderStyle: 'solid',
        content: '""',
        zIndex: 1,
      },
      '&:before': {
        top: framePadding,
        left: framePadding,
        borderWidth: `${frameWidth} 0 0 ${frameWidth}`,
      },
      '&:after': {
        top: framePadding,
        right: framePadding,
        borderWidth: `${frameWidth} ${frameWidth} 0 0`,
      },
      '&>:first-child:before': {
        bottom: framePadding,
        right: framePadding,
        borderWidth: `0 ${frameWidth} ${frameWidth} 0`,
      },
      '&>:first-child:after': {
        bottom: framePadding,
        left: framePadding,
        borderWidth: `0 0 ${frameWidth} ${frameWidth}`,
      },
    },
    readerContainer: ({ styles }: { styles: Record<string, unknown> }) => ({
      width: '100%',
      height: '100%',
      padding: theme.spacing(1),
      borderRadius: theme.spacing(2),
      ...styles,
      '& video': {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      },
    }),
  };
});
